import logo from './logo.svg';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { googleLogout } from '@react-oauth/google';

function App() {
  return (
    <GoogleOAuthProvider clientId="290908974437-v2jafct87bu1e8h0odqgr478fiolcpkq.apps.googleusercontent.com">
      <GoogleLogin
        onSuccess={credentialResponse => {
          sessionStorage.setItem('jwt', credentialResponse.credential);
        }}
        onError={() => {
          console.log('Login Failed');
        }}
      />
      <button onClick={() => alert("ok")}>Logout</button>
    </GoogleOAuthProvider>

  );
}

export default App;
